import * as Yup from "yup";
import dayjs from "dayjs";
import { IGoodsIssue } from "../../../../types/Inventory/GoodsIssue";
import { Tracability } from "../../../../generated/inventory";

export const goodsIssueSchema: IGoodsIssue = {
  unique_id: "",
  type: "",
  reference_unique_id: "",
  warehouse_id: undefined,
  created_date: dayjs(),
  posted_date: dayjs(),
  remark: "",
  trace_entry_list: [],
  created_by: null,
  branch_id: undefined,
  flag_status: [],
  main_status: "",
  aggrid_status: "",
};

export const goodsIssueTraceValidation = Yup.object().shape({
  stock_qty: Yup.number().nullable(),
  qty: Yup.number()
    .transform((value) =>
      isNaN(value) || value === null || value === undefined ? 0 : value
    )
    .min(1, "กรุณาระบุจำนวนที่นำออก")
    .required("กรุณาระบุจำนวนที่นำออก")
    .when(
      "stock_qty",
      (value: any, schema) =>
        (value || value === 0) &&
        schema.max(value, "กรุณาระบุจำนวนนำออกไม่เกินจำนวนในคลัง")
    ),
});

export const goodsIssueSerialValidation = Yup.object().shape({
  stock_qty: Yup.number().nullable(),
  qty: Yup.number()
    .when("tracability", (tracability: any) =>
      tracability && tracability[0] === Tracability.Normal
        ? Yup.number()
            .transform((value) =>
              isNaN(value) || value === null || value === undefined ? 0 : value
            )
            .min(1, "กรุณาระบุจำนวนที่นำออก")
            .required("กรุณาระบุจำนวนที่นำออก")
        : Yup.number().nullable()
    )
    .when(
      "stock_qty",
      (value: any, schema) =>
        (value || value === 0) &&
        schema.max(value, "กรุณาระบุจำนวนนำออกไม่เกินจำนวนในคลัง")
    ),
  serial_list: Yup.array().when("tracability", (tracability: any) =>
    tracability && tracability[0] === Tracability.Serial
      ? Yup.array()
          .of(goodsIssueTraceValidation)
          .min(1, "กรุณาสแกนรายการสินค้า")
      : Yup.array().nullable()
  ),
});

export const goodsIssueValidation = Yup.object().shape({
  unique_id: Yup.string().required("กรุณาระบุเลขที่เอกสาร"),
  type: Yup.string().required("กรุณาระบุประเภท"),
  warehouse_id: Yup.string().required("กรุณาระบุคลัง"),
  reference_unique_id: Yup.string().when("type", (type: any) => {
    if (type[0] && type[0] !== "other") {
      return Yup.string().required("กรุณาระบุเอกสารอ้างอิง");
    } else {
      return Yup.string();
    }
  }),
  trace_entry_list: Yup.array()
    .of(goodsIssueSerialValidation)
    .min(1, "กรุณาเพิ่มสินค้า"),
});
